import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MdAccountBalance, MdReceiptLong, MdInsights, MdAccountBalanceWallet, MdMenuBook } from 'react-icons/md';
import FinanceOverview from './FinanceOverview';
import FinanceLedger from './FinanceLedger';
import { ExpensesPanel } from './Expenses';
import Receivables from './Receivables';
import FinanceReports from './FinanceReports';

const tabs = [
  { id: 'overview',     label: 'Overview',     icon: MdAccountBalance },
  { id: 'ledger',       label: 'Ledger',       icon: MdMenuBook },
  { id: 'expenses',     label: 'Expenses',     icon: MdReceiptLong },
  { id: 'receivables',  label: 'Receivables',  icon: MdAccountBalanceWallet },
  { id: 'reports',      label: 'Reports',      icon: MdInsights },
];

export default function Finance() {
  document.title = 'Finance — TrainAxis';
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'overview');
  const [drillMonth, setDrillMonth] = useState(null); // AD "YYYY-MM" target from Reports drill-down

  // Reports row → open that month in Overview.
  const handleDrillToMonth = (monthStr) => {
    setDrillMonth(monthStr);
    setActiveTab('overview');
  };

  useEffect(() => {
    setSearchParams({ tab: activeTab }, { replace: true });
  }, [activeTab, setSearchParams]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-secondary flex items-center gap-2">
          <MdAccountBalance className="text-primary" /> Finance
        </h1>
        <p className="text-sm text-muted mt-0.5">Track your club's income, expenses, and profitability</p>
      </div>

      {/* Tab Navigation */}
      <div className="flex gap-1 mb-6 border-b border-divider">
        {tabs.map(tab => {
          const TabIcon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold transition-colors border-b-2 -mb-px ${
                isActive
                  ? 'border-secondary text-secondary'
                  : 'border-transparent text-muted hover:text-secondary'
              }`}
            >
              <TabIcon className="text-base" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'overview' && <FinanceOverview onNavigateTab={setActiveTab} initialMonth={drillMonth} />}
        {activeTab === 'ledger' && <FinanceLedger />}
        {activeTab === 'expenses' && <ExpensesPanel />}
        {activeTab === 'receivables' && <Receivables />}
        {activeTab === 'reports' && <FinanceReports onDrillToMonth={handleDrillToMonth} />}
      </div>
    </div>
  );
}
